export default {
    secretPlaces: {
        password: 'SATANAS EXISTIT'
    }
}